import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getCountryDeclensionWhereById} from "../../investment_offer/utils/get_country_declension_where";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {hitSearchSubmit} from "../tracking/hit_search_submit";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {SearchTab} from "../types/SearchTab";
import {getHitSearchSubmitLabel} from "../utils/get_hit_search_submit_label";
import {getSearchTerm} from "../utils/get_search_term";

export const useHitSearchSubmit = () => {
    const tabData = useSelector((state: IRPStore) => state.search.currentTabData);
    const tabCategory = tabData.currentTab === SearchTab.Holiday ? "Wakacyjne" : getCountryDeclensionWhereById(tabData.country);

    const articleTitle = useSelector((state: IRPStore) => state.article.detail.article?.header);
    const viewType = useSelector((state: IRPStore) => state.viewType);
    const offerListTitle = useSelector((state: IRPStore) => state.metaData.standardMetaData.title);
    const label = getHitSearchSubmitLabel(offerListTitle, viewType.current, articleTitle);

    return (formValues: ISearchFormValues) => {
        const searchValue = formValues.search as ISearchInputValue;
        const searchTerm = getSearchTerm(searchValue);

        hitSearchSubmit(searchTerm, tabCategory, label);
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getCountryDeclensionWhereById} from "../../investment_offer/utils/get_country_declension_where";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {hitSearchSubmit} from "../tracking/hit_search_submit";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {SearchTab} from "../types/SearchTab";
import {getHitSearchSubmitLabel} from "../utils/get_hit_search_submit_label";
import {getSearchTerm} from "../utils/get_search_term";

export const useHitSearchSubmit = () => {
    const tabData = useSelector((state: IRPStore) => state.search.currentTabData);
    const tabCategory = tabData.currentTab === SearchTab.Holiday ? "Wakacyjne" : getCountryDeclensionWhereById(tabData.country);

    const articleTitle = useSelector((state: IRPStore) => state.article.detail.article?.header);
    const viewType = useSelector((state: IRPStore) => state.viewType);
    const offerListTitle = useSelector((state: IRPStore) => state.metaData.standardMetaData.title);
    const label = getHitSearchSubmitLabel(offerListTitle, viewType.current, articleTitle);

    return (formValues: ISearchFormValues) => {
        const searchValue = formValues.search as ISearchInputValue;
        const searchTerm = getSearchTerm(searchValue);

        hitSearchSubmit(searchTerm, tabCategory, label);
    };
};
